import {
    Fab,
    Theme,
    makeStyles,
    createStyles,
    ThemeProvider,
    createMuiTheme,
    BottomNavigation,
    BottomNavigationAction,
} from '@material-ui/core';
import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import CalendarIcon from '@material-ui/icons/DateRange';
import SearchIcon from '@material-ui/icons/Search'
import PlannerIcon from '@material-ui/icons/School'
import FeedIcon from '@material-ui/icons/RssFeed'
import {useAuthState} from "react-firebase-hooks/auth";
import Firebase from 'firebase/app';
import 'firebase/auth'
import useCourses from "../Common/Context/Consumers/useCourses";

interface FooterProps {
    page: string;
    setOpen: () => void;
    onSelect: (page: string) => void;
}

export const Footer = (props: FooterProps) => {
    const {
        page,
        setOpen,
        onSelect
    } = props;
    const classes = useStyles();
    const [user, userLoading, userError] = useAuthState(Firebase.auth());
    const semesters: any = useCourses();

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.bottomNav}>
                <div className={classes.fabContainer}>
                    <Fab
                        data-tutorial={'tut-4'}
                        onClick={setOpen}
                    >
                        <SearchIcon
                            component={'svg'}
                        />
                    </Fab>
                </div>
                <BottomNavigation
                    value={page}
                    onChange={(event: React.ChangeEvent<{}>, newValue: string) => {
                        onSelect(newValue);

                        switch(newValue) {
                            case 'planner':
                                Firebase.analytics().logEvent('Footer', { page_location:  'Footer/Planner', page_title: 'Planner'});
                                break;
                            case 'dashboard':
                                Firebase.analytics().logEvent('Footer', { page_location:  'Footer/Dashboard', page_title: 'Dashboard'});
                                break;
                            case 'calendar':
                                Firebase.analytics().logEvent('Footer', { page_location:  'Footer/Calendar', page_title: 'Calendar'});
                                break;
                            case 'feed':
                                Firebase.analytics().logEvent('Footer', { page_location:  'Footer/Feed', page_title: 'Feed'});
                                break;
                            default:
                            // code block
                        }
                    }
                    }
                    className={classes.bottom}
                >
                    {user &&
                    <BottomNavigationAction
                        label={'Planner'}
                        value={'planner'}
                        icon={<PlannerIcon/>}
                    />
                    }
                    <BottomNavigationAction
                        data-tutorial={"tut-3"}
                        label={'Dashboard'}
                        value={'dashboard'}
                        icon={<PersonIcon/>}
                    />
                    <BottomNavigationAction
                        data-tutorial={"tut-6"}
                        label={'Calendar'}
                        value={'calendar'}
                        icon={<CalendarIcon/>}
                    />
                    <BottomNavigationAction
                        label={'Feed'}
                        value={'feed'}
                        icon={<FeedIcon/>}
                    />
                </BottomNavigation>
            </div>
        </ThemeProvider>
    )
};

const useStyles: any = makeStyles((theme: Theme) => createStyles({

        bottom: {
            width: '100%',
            margin: 0,
            backgroundColor: 'white'
        },
        fabContainer: {
            position: 'fixed',
            zIndex: 50,
            bottom: 72,
            left: '50%',
            transform: 'translate(-50%, 0)'


        },
        bottomNav: {
            flex: 1,
            bottom: 0,
        }

    })
);

const theme: Theme = createMuiTheme({
    overrides: {
        MuiBottomNavigationAction: {
            root: {
                '&$selected': {
                    color: '#046A38'

                },
                maxWidth: '100%'
            }

        },
        MuiFab: {
            root: {
                backgroundColor: '#046A38',
                color: 'white',
                '&:hover': {
                    backgroundColor: '#046A38'
                },
                border: 'white 3px solid'
            }
        }
    }
});